export default "__VITE_ASSET__BBN2gQgs__"